import { Checkbox as BaseCheckbox } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseCheckbox)
